


































































import Vue from 'vue';
import { mapState } from 'vuex';
import Api from '@/mixins/api';
import Helpers from '../mixins/helpers';
import axios from 'axios';
import FieldDropdown from '@/components/dumb/FieldDropdown.vue';
import FieldRadioButton from '@/components/dumb/FieldRadioButton.vue';
import FieldText from '@/components/dumb/FieldText.vue';
import Analytics from '@/mixins/analytics';
export default Vue.extend({
	name: 'FallbackForm', 
	components: {
		FieldText, 
		FieldDropdown, 
		FieldRadioButton
	},
	data(): any {
		return {
			isFormValid: false, 
			isProcessing: false, 
			states: [
				'Overseas',
				'ACT',
				'NSW',
				'NT',
				'QLD',
				'SA',
				'TAS',
				'VIC',
				'WA',
			],
			licenseOrigins: [
				'Australia', 
				'Overseas'
			], 
		};
	}, 
	computed: {
		...mapState({
			app(): any { return this.$store.state.app }, 
			vehicle(): any { return this.$store.state.vehicle }, 
			dealer(): any { return this.$store.state.dealer }, 
			customer(): any { return this.$store.state.customer }, 
			disclaimers(): any { return this.$store.state.disclaimers }, 
		}),
		flow(): string {
			return this.$store.getters.flow;
		},
		isLicenseStateVisible(): boolean {
            return this.customer.licenseOrigin == 'Australia';
		},
		livingStatus(): any {
			return Helpers.livingStatus;
		},
		driverLicenceValidation(): Array<Function> {
			return [(v: string) => !!v && v.length >= 4 && (this.isLicenseStateVisible ? v.length < 10 : v.length < 16)];
		},
		customerLivingStatus: {
            get(): string {
                return this.customer.livingStatus;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    livingStatus: v
                });
            }
		},
		customerLicenseOrigin: {
            get(): string {
                return this.customer.licenseOrigin;
            },
            set(v){
                this.$store.commit('setCustomer', {
                    licenseOrigin: v
                });
            }
		},
		customerLicenseNumber: {
            get(): string {
                return this.customer.licenseNumber;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    licenseNumber: v
                });
            }
		},
		customerLicenseState: {
            get(): string {
                return this.customer.licenseState;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    licenseState: v
                });
            }
		},
		customerPrivacyAcceptedFallback: {
            get(): string {
                return this.customer.privacyAcceptedFallback;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    privacyAcceptedFallback: v
                });
            }
		}
	}, 
	methods: {
		handlePrivacyPolicyClick(e: any): void {
			e.stopPropagation();
			(window as any).open('https://www.toyota.com.au/privacy', '_blank');
		},
		handleContinueClick(): void {
			if (this.flow == 'business'){
				Analytics.sendEvent({
					'event':'buttonClick',
					'buttonName':'Business Finance - Continue'
				});
			}
			else if (this.flow == 'indicative'){
				Analytics.sendEvent({
					'event':'buttonClick',
					'buttonName':'Indicative Finance - Continue'
				});
			}
			this.isProcessing = true;
			this.postFinanceLead();
		}, 
		handleFieldUpdate(fieldName: string, name: string, val: string): void {
			const suffix = Analytics.getSuffix();
			Analytics.sendEvent({
				"event": "formInteraction",
				"formName" : "Toyota Personalised Rate Form" + suffix,
				"fieldName" : fieldName,
				"fieldStatus" : "Edited"
			});
			if ('licenceState' == name){
				this.$store.commit('setCustomer', {
					licenseOrigin: (val == 'Overseas') ? 'Overseas' : 'Australia'
				});
			}
		}, 
		postFinanceLead(): void {
			Api.postLeadStart((response: any) => {
				this.$store.commit('setApp', {
					financeLeadOrderNumber: response.data.OrderNumber
				});
				if (this.flow == 'business'){
					Analytics.sendEvent({
						"event": "businessFinanceStage",
						"stageName" : "Business Access Loan Applied"
					});
				}
				else if (this.flow == 'indicative'){
					Analytics.sendEvent({
						"event": "IndicativeFinanceStage",
						"stageName" : "Indicative Applied"
					});
				}
				this.$emit('submitted');
				this.isProcessing = false;
			}, () => {
				this.isProcessing = false;
			});
			return;
		}
	}, 
	mounted(): void {
		Analytics.sendEvent({
			"event": "businessFinanceStage",
			"stageName" : "Business Access Loan Start"
		});
	}
});
